/**
 * Objet de configuration de date
 * Contient des infos liées à la locale
 */
export class WizDateLocaleObj {

    /** Code de la locale */
    public locale: string;

    /** Caractère de séparation d'éléments de date */
    public dateSeparator: string;

    /** Caractère de séparation d'éléments d'heure' */
    public hourSeparator: string;

    /** Pattern de date au format numerique */
    public datePattern: string;
}
